import React from 'react'

function MedicineMaster() {
  return (
    <div>Medicine Master (name, batch, expiry, MRP, stock)</div>
  )
}

export default MedicineMaster